'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  useSectionsPaginated
} from "./chunk-VSTAKFRX.mjs";
import {
  useGetAppCard
} from "./chunk-FHQPRS6P.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/stories/AppStory.tsx
import { useRef, useState } from "react";
import { Button, ShareModal, Spinner, Typography } from "@wbk/ui";
import { PlayIcon, ShareIcon } from "@wbk/svg";
import { Link, useRouter, useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var AppStory = ({ id }) => {
  var _a;
  const { locale } = useRouter();
  const { t } = useTranslation("contentful_common");
  const [playFallback, setPlayFallback] = useState(false);
  const videoRef = useRef(null);
  const { data, isLoading } = useGetAppCard({ lang: locale, id });
  const hasStory = !!(data == null ? void 0 : data.video) || !!(data == null ? void 0 : data.backgroundImage);
  const hasFooter = (data == null ? void 0 : data.cardTitle) || (data == null ? void 0 : data.cardSubtitle);
  const handleVideoLoaded = (video) => __async(null, null, function* () {
    try {
      setPlayFallback(false);
      yield video == null ? void 0 : video.play();
    } catch (error) {
      setPlayFallback(true);
    }
  });
  return /* @__PURE__ */ jsx("section", { className: "container p-2 py-12", children: isLoading ? /* @__PURE__ */ jsx("div", { className: "flex h-full min-h-[60vh] items-center justify-center", children: /* @__PURE__ */ jsx(Spinner, { className: "h-10 w-10" }) }) : hasStory ? /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-sm", children: [
    /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      playFallback && /* @__PURE__ */ jsx("div", { className: "absolute left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center", children: /* @__PURE__ */ jsx(
        Button,
        {
          shape: "text",
          theme: "action",
          onClick: () => {
            setPlayFallback(false);
            handleVideoLoaded(videoRef.current);
          },
          children: /* @__PURE__ */ jsx(PlayIcon, { className: "h-40 w-40" })
        }
      ) }),
      /* @__PURE__ */ jsx(
        ContentfulMedia_default,
        {
          ref: videoRef,
          className: "mx-auto aspect-[9/16] h-[calc(100vh-250px)] w-full max-w-[98%] overflow-hidden object-cover object-top",
          media: data.video || data.backgroundImage,
          poster: (_a = data.backgroundImage) == null ? void 0 : _a.url,
          placeholder: true,
          autoPlay: true,
          onLoadedMetadata: (e) => handleVideoLoaded(e.target)
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "to-body absolute -bottom-1 h-40 w-full bg-gradient-to-b from-transparent" })
    ] }),
    hasFooter && /* @__PURE__ */ jsxs("div", { className: "gap-S relative z-50 flex items-center justify-center p-4 text-start", children: [
      (data == null ? void 0 : data.thumbnail) && /* @__PURE__ */ jsx(
        ContentfulMedia_default,
        {
          media: data == null ? void 0 : data.thumbnail,
          width: 48,
          height: 48,
          className: "h-12 w-12 object-cover"
        }
      ),
      (data == null ? void 0 : data.cardTitle) && /* @__PURE__ */ jsxs("div", { className: "grow space-y-1", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "label-M", children: data.cardTitle }),
        (data == null ? void 0 : data.cardSubtitle) && /* @__PURE__ */ jsx(Typography, { variant: "body-S", color: "text-secondary", children: data.cardSubtitle })
      ] }),
      (data == null ? void 0 : data.cardLink) && /* @__PURE__ */ jsx(Button, { as: Link, href: data.cardLink, children: (data == null ? void 0 : data.cardLinkLabel) || t("contentful_common:learn_more") }),
      /* @__PURE__ */ jsx(
        ShareModal,
        {
          icon: /* @__PURE__ */ jsx(ShareIcon, { className: "h-5 w-5" }),
          data: { title: data == null ? void 0 : data.cardTitle },
          onClose: () => {
            handleVideoLoaded(videoRef.current);
          },
          render: ({ share }) => /* @__PURE__ */ jsx(
            Button,
            {
              shape: "text",
              theme: "action",
              className: "p-2",
              onClick: () => {
                var _a2;
                (_a2 = videoRef.current) == null ? void 0 : _a2.pause();
                share();
              },
              children: /* @__PURE__ */ jsx(ShareIcon, { className: "h-6 w-6" })
            }
          )
        }
      )
    ] })
  ] }) : /* @__PURE__ */ jsxs("div", { className: "space-y-4 text-center", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "heading-M", children: t("contentful_common:story.empty") }),
    /* @__PURE__ */ jsx(Button, { as: Link, theme: "action", shape: "outlined", children: t("contentful_common:story.back_home") })
  ] }) });
};
var AppStory_default = AppStory;

// src/components/stories/Stories.tsx
import { useEffect as useEffect3, useMemo, useState as useState3 } from "react";
import { Button as Button3, Carousel, ResponsiveModal } from "@wbk/ui";
import { getItem, safeParseJson, setItem } from "@wbk/utils";
import { ChevronIcon as ChevronIcon2 } from "@wbk/svg";
import { useRouter as useRouter3 } from "@wbk/config";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";

// src/components/stories/StoriesGallery.tsx
import { useEffect, useRef as useRef2, useState as useState2 } from "react";
import { Button as Button2, ShareModal as ShareModal2, Typography as Typography2 } from "@wbk/ui";
import { ChevronIcon, CloseIcon, PlayIcon as PlayIcon2, ShareIcon as ShareIcon2 } from "@wbk/svg";
import { motion } from "motion/react";
import { Link as Link2, useRouter as useRouter2 } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var StoriesGallery = ({ items, initialIndex, onWatch, onClose, sectionId }) => {
  var _a;
  const [currentIndex, setCurrentIndex] = useState2(initialIndex);
  const [duration, setDuration] = useState2(0);
  const [playFallback, setPlayFallback] = useState2(false);
  const videoRef = useRef2(null);
  const currentItem = items[currentIndex];
  const { pathname } = useRouter2();
  const { trackEvent } = useAnalytics();
  const startedAtRef = useRef2(Date.now());
  const durationRef = useRef2(0);
  const viewTrackedRef = useRef2(false);
  useEffect(() => {
    if (duration <= 0) return;
    durationRef.current = duration;
    startedAtRef.current = Date.now();
  }, [currentIndex, duration]);
  useEffect(() => {
    viewTrackedRef.current = false;
  }, [currentIndex]);
  const completionPercentage = () => {
    const total = durationRef.current;
    if (!total) return 0;
    const elapsed = (Date.now() - startedAtRef.current) / 1e3;
    return Math.max(0, Math.min(100, Math.round(elapsed / total * 100)));
  };
  const storyData = (item, index) => ({
    type: item.__typename,
    slug: item.id,
    label: item.title,
    section: sectionId,
    position: index,
    page: pathname
  });
  const trackCurrentView = () => {
    if (viewTrackedRef.current || !currentItem) return;
    viewTrackedRef.current = true;
    trackEvent({
      event: "story_viewed",
      data: __spreadProps(__spreadValues({}, storyData(currentItem, currentIndex)), {
        completion_percentage: completionPercentage()
      })
    });
  };
  const trackStoryAction = (actionType) => {
    trackEvent({
      event: "story_action_clicked",
      data: __spreadValues(__spreadProps(__spreadValues({}, storyData(currentItem, currentIndex)), {
        action_type: actionType
      }), actionType === "book" && { href: currentItem.href })
    });
  };
  const leaveRef = useRef2(trackCurrentView);
  leaveRef.current = trackCurrentView;
  useEffect(() => () => leaveRef.current(), []);
  const hasFooter = currentItem.image || currentItem.title || currentItem.subtitle || currentItem.buttonLabel;
  const goToNextStory = () => {
    trackCurrentView();
    const nextItem = items[currentIndex + 1];
    if (nextItem == null ? void 0 : nextItem.background) {
      onWatch(nextItem.background.sys.id);
    }
    if (currentIndex < items.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onClose();
    }
  };
  const goToPreviousStory = () => {
    trackCurrentView();
    const prevItem = items[currentIndex - 1];
    if (prevItem == null ? void 0 : prevItem.background) {
      onWatch(prevItem.background.sys.id);
    }
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleClose = () => {
    trackStoryAction("close");
    trackCurrentView();
    onClose();
  };
  const handleVideoLoaded = (video) => __async(null, null, function* () {
    try {
      setPlayFallback(false);
      yield video == null ? void 0 : video.play();
      const duration2 = (video == null ? void 0 : video.duration) || 5;
      const played = (video == null ? void 0 : video.played.length) > 0 ? video == null ? void 0 : video.played.end(0) : 0;
      const timeLeft = duration2 - played;
      setDuration(timeLeft);
    } catch (error) {
      setPlayFallback(true);
    }
  });
  const generateShareURL = (id) => {
    if (typeof window !== "undefined") {
      const base = window.location.origin;
      const path = window.location.pathname;
      const query = `?story=${id}`;
      return `${base}${path}${query}`;
    }
    return "";
  };
  return /* @__PURE__ */ jsxs2("div", { className: "rounded-S bg-body relative inline-block w-full", children: [
    /* @__PURE__ */ jsx2(
      "button",
      {
        className: "absolute bottom-0 z-20 h-[80%] w-1/2 focus:outline-none ltr:left-0 rtl:right-0",
        onClick: goToPreviousStory
      }
    ),
    /* @__PURE__ */ jsx2(
      "button",
      {
        className: "absolute bottom-0 z-20 h-[80%] w-1/2 focus:outline-none ltr:right-0 rtl:left-0",
        onClick: goToNextStory
      }
    ),
    /* @__PURE__ */ jsx2(
      Button2,
      {
        theme: "transparent",
        onClick: goToPreviousStory,
        className: "ring-action bg-body/60 absolute top-1/2 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full lg:flex ltr:-left-20 ltr:-scale-x-100 rtl:-right-20",
        children: /* @__PURE__ */ jsx2(ChevronIcon, {})
      }
    ),
    /* @__PURE__ */ jsx2(
      Button2,
      {
        theme: "transparent",
        onClick: goToNextStory,
        className: "ring-action bg-body/60 absolute top-1/2 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full lg:flex ltr:-right-20 rtl:-left-20 rtl:-scale-x-100",
        children: /* @__PURE__ */ jsx2(ChevronIcon, {})
      }
    ),
    /* @__PURE__ */ jsxs2("div", { className: "relative", children: [
      playFallback && /* @__PURE__ */ jsx2("div", { className: "absolute left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center", children: /* @__PURE__ */ jsx2(
        Button2,
        {
          shape: "text",
          theme: "action",
          onClick: () => {
            setPlayFallback(false);
            handleVideoLoaded(videoRef.current);
          },
          children: /* @__PURE__ */ jsx2(PlayIcon2, { className: "h-40 w-40" })
        }
      ) }),
      /* @__PURE__ */ jsx2(
        ContentfulMedia_default,
        {
          ref: videoRef,
          media: currentItem.background,
          poster: (_a = currentItem.image) == null ? void 0 : _a.url,
          className: "rounded-S aspect-[9/16] h-[calc(100vh-200px)] max-h-[780px] w-full overflow-hidden object-cover object-top",
          placeholder: true,
          autoPlay: true,
          onLoad: () => {
            setDuration(5);
          },
          onLoadedMetadata: (e) => handleVideoLoaded(e.target)
        },
        currentItem.sys.id
      ),
      /* @__PURE__ */ jsx2("div", { className: "to-body absolute -bottom-2 h-40 w-full bg-gradient-to-b from-transparent" })
    ] }),
    hasFooter && /* @__PURE__ */ jsxs2("div", { className: "gap-S relative z-50 flex items-center justify-center p-6 text-start", children: [
      currentItem.title && currentItem.image && /* @__PURE__ */ jsx2(
        ContentfulMedia_default,
        {
          media: currentItem.image,
          width: 48,
          height: 48,
          className: "h-12 w-12 object-cover"
        }
      ),
      currentItem.title && /* @__PURE__ */ jsxs2("div", { className: "grow space-y-1", children: [
        /* @__PURE__ */ jsx2(Typography2, { variant: "label-M", children: currentItem.title }),
        currentItem.subtitle && /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", color: "text-secondary", children: currentItem.subtitle })
      ] }),
      currentItem.buttonLabel && /* @__PURE__ */ jsx2(Button2, { as: Link2, to: currentItem.href, onClick: () => trackStoryAction("book"), children: currentItem.buttonLabel }),
      currentItem.background && /* @__PURE__ */ jsx2(
        ShareModal2,
        {
          data: { title: currentItem.title, url: generateShareURL(currentItem.sys.id) },
          poster: currentItem.image.url,
          onClose: () => {
            handleVideoLoaded(videoRef.current);
          },
          render: ({ share }) => /* @__PURE__ */ jsx2(
            Button2,
            {
              shape: "text",
              theme: "action",
              className: "p-2",
              onClick: () => {
                var _a2;
                trackStoryAction("share");
                setDuration(0);
                (_a2 = videoRef.current) == null ? void 0 : _a2.pause();
                share();
              },
              children: /* @__PURE__ */ jsx2(ShareIcon2, { className: "h-6 w-6" })
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "absolute top-6 z-20 w-full space-y-4 px-6 lg:top-4", children: [
      /* @__PURE__ */ jsx2("div", { className: "flex w-full gap-2", children: items.map((_, i) => /* @__PURE__ */ jsx2(
        "div",
        {
          "data-prev": i < currentIndex,
          className: "bg-body-dark/10 data-[prev=true]:bg-body-dark relative h-1 grow overflow-hidden rounded-full",
          children: i === currentIndex && duration > 0 && /* @__PURE__ */ jsx2(
            motion.div,
            {
              className: "bg-body-dark h-full",
              initial: { width: "1%" },
              animate: { width: "100%" },
              transition: { duration, ease: "linear" },
              onAnimationComplete: () => {
                goToNextStory();
              }
            },
            duration
          )
        },
        i
      )) }),
      /* @__PURE__ */ jsxs2("div", { className: "gap-S flex items-center justify-center", children: [
        currentItem.icon && /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: currentItem.icon, className: "max-w-16" }),
        /* @__PURE__ */ jsx2(
          Button2,
          {
            theme: "action",
            shape: "text",
            className: "p-2 ltr:ml-auto rtl:mr-auto",
            onClick: handleClose,
            children: /* @__PURE__ */ jsx2(CloseIcon, {})
          }
        )
      ] })
    ] })
  ] });
};
var StoriesGallery_default = StoriesGallery;

// src/components/stories/AutoLoadMore.tsx
import { useEffect as useEffect2, useRef as useRef3 } from "react";
import { useInView } from "motion/react";
import { twMerge } from "tailwind-merge";
import { Spinner as Spinner2 } from "@wbk/ui";
import { jsx as jsx3 } from "react/jsx-runtime";
var AutoLoadMore = ({ hasMore, isFetching, fetch }) => {
  const ref = useRef3(null);
  const isInView = useInView(ref, { margin: "0px -150px 0px -150px" });
  useEffect2(() => {
    if (hasMore && isInView && !isFetching) {
      fetch();
    }
  }, [hasMore, isInView]);
  return /* @__PURE__ */ jsx3(
    "div",
    {
      className: twMerge(
        "h-24 w-24 shrink-0 rounded-full ltr:mr-2.5 rtl:ml-2.5",
        !hasMore && "hidden"
      ),
      ref,
      children: /* @__PURE__ */ jsx3("div", { className: "bg-body border-paper flex h-24 w-24 shrink-0 animate-pulse cursor-wait items-center justify-center rounded-full border-4 p-0", children: /* @__PURE__ */ jsx3(Spinner2, {}) })
    }
  );
};
var AutoLoadMore_default = AutoLoadMore;

// src/components/stories/Stories.tsx
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var getWatchedStories = () => {
  return safeParseJson(getItem("stories_watched") || "{}");
};
var ContentfulStories = ({ section, className = "", render }) => {
  var _a, _b;
  const { locale, search } = useRouter3();
  const [watched, setWatched] = useState3({});
  const { trackEvent } = useAnalytics2();
  const isInfinite = ((_a = section.contentCollection) == null ? void 0 : _a.items.length) >= 20;
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useSectionsPaginated({
    lang: locale,
    limit: 1,
    contentLimit: 20,
    where: { id: section.id },
    options: {
      enabled: isInfinite
    }
  });
  const storyID = search.get("story");
  const stories = useMemo(() => {
    var _a2;
    const cards = data || ((_a2 = section.contentCollection) == null ? void 0 : _a2.items) || [];
    const filteredStories = cards.filter((story) => !!story.background);
    if (storyID) {
      return filteredStories.sort((a) => a.sys.id === storyID ? -1 : 1);
    }
    return filteredStories;
  }, [data, (_b = section.contentCollection) == null ? void 0 : _b.items, storyID]);
  useEffect3(() => {
    if (storyID) {
      const story = document.getElementById(storyID);
      if (story) {
        story.scrollIntoView({ block: "center" });
        story.click();
      }
    }
  }, [storyID]);
  useEffect3(() => {
    setWatched(getWatchedStories());
  }, []);
  const handleWatch = (id) => {
    const items = getWatchedStories();
    items[id] = true;
    setWatched(items);
    setItem("stories_watched", JSON.stringify(items));
  };
  if (!(stories == null ? void 0 : stories.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs3(DecoratedSection_default, { section, className: `container overflow-hidden ${className}`, children: [
    /* @__PURE__ */ jsx4("h2", { className: "bg-gradient-to-bl from-[#7B49FF] to-[#FF2C79] bg-clip-text pb-2 text-xl font-semibold text-transparent", children: section.title }),
    /* @__PURE__ */ jsxs3(
      Carousel,
      {
        className: "p-1",
        options: { dragFree: true },
        renderHeader: ({ scrollPrev, scrollNext }) => /* @__PURE__ */ jsxs3(Fragment, { children: [
          /* @__PURE__ */ jsx4("div", { className: "bg-body absolute bottom-12 top-20 z-10 hidden h-[calc(100%-110px)] items-center justify-center p-1 md:flex ltr:left-0 rtl:right-0", children: /* @__PURE__ */ jsx4(
            Button3,
            {
              theme: "action",
              className: "-mt-4 h-[60px] w-[60px] shrink-0 rounded-full p-0",
              onClick: scrollPrev,
              children: /* @__PURE__ */ jsx4(ChevronIcon2, { className: "h-5 w-5 ltr:rotate-180" })
            }
          ) }),
          /* @__PURE__ */ jsx4("div", { className: "bg-body absolute bottom-12 top-20 z-10 hidden h-[calc(100%-110px)] items-center justify-center p-1 md:flex ltr:right-0 rtl:left-0", children: /* @__PURE__ */ jsx4(
            Button3,
            {
              theme: "action",
              className: "-mt-4 h-[60px] w-[60px] shrink-0 rounded-full p-0",
              onClick: scrollNext,
              children: /* @__PURE__ */ jsx4(ChevronIcon2, { className: "h-5 w-5 rtl:rotate-180" })
            }
          ) })
        ] }),
        children: [
          /* @__PURE__ */ jsx4("div", { className: "h-[74px] w-0 shrink-0 md:w-[74px]" }),
          stories.map((story, i) => {
            if (!story.background) return null;
            const storyId = story.background.sys.id;
            const isNew = !watched[storyId];
            return /* @__PURE__ */ jsx4(
              ResponsiveModal,
              {
                ignoreHistory: true,
                closeButton: false,
                type: "modal",
                bodyClassName: "p-0 overflow-visible",
                className: "overflow-visible [&>*]:overflow-visible [&>*]:bg-transparent",
                render: ({ open, close, isOpen }) => render ? render({
                  open: () => {
                    open();
                    handleWatch(storyId);
                  },
                  close,
                  isOpen,
                  story
                }) : /* @__PURE__ */ jsxs3("div", { className: "space-y-2 text-center", children: [
                  /* @__PURE__ */ jsx4(
                    Button3,
                    {
                      id: story.sys.id,
                      "data-new": isNew,
                      onClick: () => {
                        var _a2;
                        open();
                        handleWatch(storyId);
                        trackEvent({
                          event: "clicked_on_section_item",
                          data: {
                            type: story.__typename,
                            item_id: (_a2 = story.sys) == null ? void 0 : _a2.id,
                            slug: story.id,
                            label: story.title,
                            section: section.id,
                            position: i
                          }
                        });
                      },
                      className: "bg-body active:bg-body border-paper hover:bg-body data-[new=true]:border-primary flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-full border-4 p-0 ltr:mr-2.5 rtl:ml-2.5",
                      children: /* @__PURE__ */ jsx4(
                        ContentfulMedia_default,
                        {
                          media: story.image,
                          className: "border-body h-20 w-20 shrink-0 rounded-full border object-cover",
                          placeholder: true
                        }
                      )
                    }
                  ),
                  story.title && /* @__PURE__ */ jsx4("p", { className: "text-text-secondary line-clamp-1 max-w-24 px-1 text-xs", children: story.title })
                ] }),
                action: false,
                cancel: false,
                body: ({ close }) => /* @__PURE__ */ jsx4(
                  StoriesGallery_default,
                  {
                    items: stories,
                    initialIndex: i,
                    sectionId: section.id,
                    onClose: close,
                    onWatch: (id) => handleWatch(id)
                  }
                )
              },
              storyId
            );
          }),
          /* @__PURE__ */ jsx4(AutoLoadMore_default, { hasMore: hasNextPage, isFetching: isFetchingNextPage, fetch: fetchNextPage }),
          /* @__PURE__ */ jsx4("div", { className: "h-[74px] w-0 shrink-0 md:w-[74px]" })
        ]
      }
    )
  ] });
};
var Stories_default = ContentfulStories;

export {
  AppStory_default,
  Stories_default
};
//# sourceMappingURL=chunk-GOKWGZLG.mjs.map